// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/preflight-journey-log-check-and-owner-duty.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/preflight-journey-log-check-and-owner-duty/preflight-journey-log-check-and-owner-duty.js';

mount([g0]);
